<template>
  <page-outline :title="$t('Webheader.injection_annuaire')">
    <template slot="primaryActions">
      <app-button
        :text="$t('common.bck')"
        icon="fa-light fa-arrow-left"
        variant="primary"
        @click="goBack"
      />
    </template>
    
    <template slot="pageContent">
      <b-container fluid>
        <form-accordion :toggleActive="false" :title="$t('annuaire.general_information')" :isTitleUpperCase="false">
          <b-row class="d-flex justify-content-center align-items-center">
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="form.name" isMandatory
                :inputLabel="$t('annuaire.file_name')" :placeholderValue="$t('annuaire.file_name')">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group d-flex flex-column">
              <label for="annuaire-file-input" class="filter-item-title">
                {{ $t('annuaire.annuaire_file') }}
                <span class="color-red">* </span>
              </label>
              <input id="annuaire-file-input" type="file" @change="handleFileUpload" accept=".csv" />
            </b-col>
          </b-row>
        </form-accordion>
      </b-container>
    </template>
    
    <template slot="bottomActions">
      <app-button
        :text="$t('common.sve')"
        icon="fa-light fa-save"
        variant="primary"
        :disabled="!form.name || !base64Data"
        @click="importTrackingFile"
      />
    </template>
  </page-outline>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from "@/components/common/PageOutline.vue";
import AppButton from '@/components/common/AppButton.vue'
import {loadPage} from "@/helpers/routing";
import {errorMessageAlert} from "@/helpers/alert";

export default {
  name: 'AnnuaireFileForm',
  components: {
    'page-outline': PageOutline,
    'app-button': AppButton,
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  data () {
    return {
      form: {
        name: '',
        id: '',
      },
      text: '',
      name: '',
      returnUrl: '/annuaire/1',
      base64Data: ''
    }
  },
  created () {
  },
  methods: {
    goBack () {
      loadPage(this, {url: this.returnUrl})
    },
    close () {
      this.showModalElement = false
    },
    handleFileUpload (event) {
      const file = event.target.files[0]
      const reader = new FileReader()

      reader.onload = (e) => {
        const csvContent = e.target.result
        this.isCSV(file)
        this.isCSVContent(csvContent)
        this.base64Data = this.convertToBase64(csvContent)
      };

      reader.readAsText(file);
    },
    isCSV (file) {
      const validMimeTypes = ['text/csv', 'application/vnd.ms-excel']
      const extension = file.name.split('.').pop().toLowerCase()
      return validMimeTypes.includes(file.type) && extension === 'csv'
    },
    isCSVContent (content) {
      const lines = content.trim().split('\n')
      if (lines.length < 2) return false

      const delimiter = content.includes(';') ? ';' : ','
      const firstLineColumns = lines[0].split(delimiter).length

      return lines.every(line => line.split(delimiter).length === firstLineColumns)
    },
    convertToBase64 (content) {
      try {
        return btoa(unescape(encodeURIComponent(content)))
      } catch (error) {
        console.error("Erreur d'encodage en base64:", error)
        return ''
      }
    },
    importTrackingFile () {
      let that = this

      if (this.formHasError()) {
        return
      }

      if (that.form.name != '' || this.base64Data != ''){

        let form = {
          Name: this.form.name,
          Content: this.base64Data
        }

        this.$engine.firstOn().annuaire.createAnnuaire(form)
        .then(resp => {
          // if (resp.headers['content-length'] && parseInt(resp.headers['content-length'], 10) !== 0) {
          if (resp.data !== '') {

            that.$f7.alert(that.$i18n.t('annuaire.import_annuaire_file'), that.$i18n.t('annuaire.file_imported'))

            loadPage(that, {url: '/annuaire/2'})
          } else {
            that.okMessageBox(that.$t('annuaire.import_annuaire_file_error'))
          }
        })
        .catch(e => {
          errorMessageAlert(e, that)
          that.okMessageBox(that.$t('annuaire.import_annuaire_file_error'))
        })
      }
    },
    isCertificateAuthority (cert) {
      const basicConstraints = cert.getExtension('basicConstraints');
      return basicConstraints && basicConstraints.cA;
    },
    formHasError () {
      let that = this
      if (this.form.name === undefined || this.form.name === '') {
        this.okMessageBox(this.$t('annuaire.file_name_missing'))
        return true
      }
      // let regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{15,40}$/
      // if (this.login === undefined || this.login === '') {
      //   this.okMessageBox(this.$t('usercompany.missing_login'))
      //   return true
      // }
      // if (this.password === undefined || this.password === '') {
      //   this.okMessageBox(this.$t('usercompany.missing_password'))
      //   return true
      // }
      // if (this.password && !regexPassword.test(this.password)) {
      //   this.okMessageBox(this.$t('profilesPage.password_wrong_format'))
      //   return true
      // }
      // if (!this.realProfileList.filter(status => status.state === 1
      //     && ((that.hrtpNorm && status.label.includes('_HRTP'))
      //         || (that.srtpNorm && status.label.includes('_SRTP'))
      //         || (!status.label.includes('_HRTP') && !status.label.includes('_SRTP')))).length) {
      //   this.okMessageBox(this.$t('usercompany.missing_profile'))
      //   return true
      // }
      // return false
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    }
  }
}
</script>
